import React from 'react'
import './footer.css'
export default function Footer() {
  return (
    <div className='footerContainer'>
      Copyright&copy; 2026. All Rights Reserved. Navram Logistics LLC.
    </div>
  )
}
